// Authentication functions
export { login } from './auth/login';
export { register } from './auth/register';

// Repository class
export { ResourceRepository } from './repositories/resource-repository';
export type { PaginatedResponse } from './repositories/resource-repository';

// Client classes
export { LoggedUserClient } from './clients/logged-user-client';

// Base classes for custom implementations
export { BaseDataSourceClient, DataSourceClient } from './base/base-client';
export type { CreateEntity, EntityWithBase } from './base/base-client';

// Core types from validation schemas
export type {
  ApiConfig,
  LoginRequest,
  RegisterRequest,
  AuthResponse,
  FindRecordsParams,
  BaseEntity,
  PaginationMeta,
  User,
  ApiError,
  LoggedUser,
  UpdateLoggedUser,
} from './features/validation/schemas';

// Error classes and type guards
export {
  ApiClientError,
  InvalidCredentialsError,
  ValidationError,
  isApiClientError,
  isInvalidCredentialsError,
  isValidationError,
} from './core/errors/api-errors';

export type { ValidationErrorDetail } from './core/errors/api-errors';

// HTTP client interfaces for advanced usage
export type {
  HttpClient,
  HttpRequest,
  HttpResponse,
} from './core/http/http-client.interface';
export { AxiosHttpClient } from './core/http/axios-http-client';

// Cache interfaces for advanced usage
export type {
  Cache,
  CacheConfig,
  CacheStrategy,
} from './features/cache/cache.interface';
export { MemoryCache } from './features/cache/memory-cache';

// Validation utilities
export { Validator } from './features/validation/validator';
export {
  ApiConfigSchema,
  LoginRequestSchema,
  RegisterRequestSchema,
  FindRecordsParamsSchema,
  BaseEntitySchema,
  PaginationMetaSchema,
  AuthResponseSchema,
  UserSchema,
  ApiErrorSchema,
  LoggedUserSchema,
  UpdateLoggedUserSchema,
} from './features/validation/schemas';

// Retry utilities
export { RetryPolicy } from './features/retry/retry-policy';
export type { RetryConfig } from './features/retry/retry-policy';

// API client interface for backward compatibility
export type { IApiClient } from './interfaces/api-client.interface';

// Factory function for ResourceRepository
import { ResourceRepository } from './repositories/resource-repository';

export function createRepository(
  baseUrl: string,
  workspaceId: string,
  accessToken: string,
  timeout?: number,
): ResourceRepository {
  return new ResourceRepository(baseUrl, workspaceId, accessToken, timeout);
}

// Version
export const VERSION = '2.0.0';

// Default export
export { ResourceRepository as default } from './repositories/resource-repository';
